module.exports = __webpack_public_path__ + "img/img3.16f03f83.png";